/**
 * Module
 */
require("./app/app.module.js");

/**
 * Constants
 */
require("./app/app.constants.js");

/**
 * Directives
 */
require("./app/widgets/creas.directives.js");
require("./app/widgets/creasSpinner/creasSpinnerDrct.js");
require("./app/widgets/creasFuna/creasFunaDrct.js");
require("./app/widgets/creasFuna/creasFunaSrvc.js");
require("./app/widgets/creasNessunRisultato/creasNessunRisultatoDrct.js");
require("./app/widgets/creasTable/creasTableDrct.js");
require("./app/widgets/creasLuogoDataDoc/creasLuogoDataDocDrct.js");
require("./app/widgets/creasDettaglioAffidamento/creasDettaglioAffidamentoDrct.js");
require("./app/widgets/creasConfirmModal/creasConfirmModalDrct.js");
require("./app/widgets/creasIbanFormatter/creasIbanFormatterDrct.js");

/**
 * Components
 */
require("./app/components/creasRicercaCliente/creasRicercaCliente.cmpt.js");
require("./app/components/creasRicercaPratiche/creasRicercaPratiche.cmpt.js");
require("./app/components/creasAffidamento/creasAffidamento.cmpt.js");

require("./app/components/creasDettaglioPratica/creasDettaglioPratica.cmpt.js");

require("./app/components/creasDettaglioPratica/creasStatoAffidamento/creasStatoAffidamento.cmpt.js");

require("./app/components/creasDettaglioPratica/creasRichiestaFido/creasRichiestaFido.cmpt.js");
require("./app/components/creasDettaglioPratica/creasRichiestaFido/creasDatiAffidamento/creasDatiAffidamento.cmpt.js");
require("./app/components/creasDettaglioPratica/creasRichiestaFido/creasGestioneFirmatari/creasGestioneFirmatari.cmpt.js");

require("./app/components/creasDettaglioPratica/creasValutazionePratica/creasValutazionePratica.cmpt.js");
require("./app/components/creasDettaglioPratica/creasValutazionePratica/creasValutazioneCerved/creasValutazioneCerved.cmpt.js");
require("./app/components/creasDettaglioPratica/creasValutazionePratica/creasIntegrazioneAnagrafica/creasIntegrazioneAnagrafica.cmpt.js");

require("./app/components/creasDettaglioPratica/creasSceltaConto/creasSceltaConto.cmpt.js");

require("./app/components/creasDettaglioPratica/creasAffidamentoDocumenti/creasAffidamentoDocumenti.cmpt.js");

require("./app/components/creasDettaglioPratica/creasPraticaPagamento/creasPraticaPagamento.cmpt.js");
require("./app/components/creasDettaglioPratica/creasPraticaPagamento/creasSceltaConvenzione/creasSceltaConvenzione.cmpt.js");
require("./app/components/creasDettaglioPratica/creasPraticaPagamento/creasSceltaPolizze/creasSceltaPolizze.cmpt.js");
require("./app/components/creasDettaglioPratica/creasPraticaPagamento/creasRiepilogoPolizze/creasRiepilogoPolizze.cmpt.js");
require("./app/components/creasDettaglioPratica/creasPraticaPagamento/creasPagamentoGestioneDocumenti/creasPagamentoGestioneDocumenti.cmpt.js");

/**
 * Services
 */
require("./app/components/servicesUtilities/labelSrvc.js");
require("./app/components/servicesUtilities/mappingSrvc.js");
require("./app/components/servicesUtilities/messaggiFctr.js");
require("./app/components/servicesUtilities/paginatoreSrvc.js");
require("./app/components/servicesUtilities/domainSrvc.js");
require("./app/components/servicesUtilities/userSrvc.js");
require("./app/components/servicesUtilities/loggerSrvc.js");
require("./app/components/servicesUtilities/creasModelFctr.js");

require("./app/components/creasDettaglioPratica/creasDettaglioPraticaSrvc.js");
require("./app/components/creasRicercaCliente/creasRicercaClienteSrvc.js");

/**
 * Run
 */
require("./app/app.run.js");

/**
 * Config
 */
require("./app/app.route.js");


//////////////////
// WEBPACK FOOTER
// ./entryRoute.js
// module id = 0
// module chunks = 1